import React from 'react';
import * as Sentry from '@sentry/react';
import { t } from 'i18next';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        console.log('ErrorBoundary getDerivedStateFromError called with:', error);
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Let the original error propagate to console
        console.log('ErrorBoundary componentDidCatch called with:', error, errorInfo);
        Sentry.captureException(error, { contexts: { react: errorInfo } });
    }

    componentDidMount() {
        // Add error handlers that don't prevent default behavior
        window.addEventListener('error', this.handleError, { capture: true });
        window.addEventListener('unhandledrejection', this.handleError, { capture: true });
    }

    componentWillUnmount() {
        window.removeEventListener('error', this.handleError, { capture: true });
        window.removeEventListener('unhandledrejection', this.handleError, { capture: true });
    }

    handleError = (event) => {
        const error = event.error || event.reason || JSON.stringify(event);
        this.setState({ hasError: true, error });
        Sentry.captureException(error);
        // Don't prevent default behavior to allow original error logging
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center p-4">
                    <div className="max-w-md w-full p-8 bg-white flex flex-col items-center text-center">

                        <h1 className="text-2xl font-bold text-gray-800 mb-4 mt-4 ">
                            {t('errorBoundary.title')}
                        </h1>
                        <p className="text-gray-600 mb-6">
                            {t('errorBoundary.message')}
                        </p>
                        <button
                            onClick={() => window.location.reload()}
                            className="w-full max-w-xs bg-gray-600 text-white py-2 px-4 rounded-full"
                        >
                            {t('errorBoundary.refresh')}
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary; 